module.exports = __webpack_public_path__ + "static/media/favicon-2.8a918218.png";